
interface HeroProps {
  onViewCert: () => void;
}

export default function Hero({ onViewCert }: HeroProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 배경 이미지 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/16d918a8541304831c7e5461839a4d10.jpg"
          alt="화악산 청정 자연 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#FDFBF7]/95 via-[#FDFBF7]/85 to-transparent"></div>
      </div>

      {/* 콘텐츠 */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* 왼쪽 텍스트 영역 */}
          <div className="space-y-8">
            <div className="inline-block bg-[#6B4E9C]/10 text-[#6B4E9C] px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
              가평 화악산의 자연과 정성
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              포도 본질을 향한<br />
              여정을 시작합니다.
            </h1>
            
            <p className="text-xl text-gray-700 leading-relaxed">
              가평 화악산의 자연과 정성을 한 병에 담습니다.<br />
              우리가 지키는 기준을 원료부터 공정까지 차례로 설명합니다.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <button 
                onClick={scrollToPurchase}
                className="bg-[#6B4E9C] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#5A3D8B] transition-colors cursor-pointer whitespace-nowrap"
              >
                지금 구매하기
              </button>
              <button 
                onClick={onViewCert}
                className="bg-white text-[#6B4E9C] px-8 py-4 rounded-lg font-bold text-lg border-2 border-[#6B4E9C] hover:bg-[#6B4E9C]/5 transition-colors cursor-pointer whitespace-nowrap"
              >
                검사성적서 보기
              </button>
            </div>
          </div>

          {/* 오른쪽 제품 이미지 */}
          <div className="relative">
            <div className="relative z-10">
              <img 
                src="https://readdy.ai/api/search-image?query=Premium%20purple%20grape%20juice%20product%20photography%20in%20elegant%20transparent%20pouch%20packaging%20with%20fresh%20purple%20grapes%20arranged%20artistically%20beside%20it%2C%20clean%20white%20background%20with%20subtle%20shadows%2C%20professional%20studio%20lighting%20highlighting%20the%20rich%20deep%20purple%20color%20of%20the%20juice%2C%20minimalist%20composition%20emphasizing%20purity%20and%20quality%2C%20high-end%20food%20photography%20style%2C%20ultra%20sharp%20details%2C%20commercial%20product%20shot&width=800&height=1000&seq=product-main-001&orientation=portrait"
                alt="화악산 암반수 저온착즙 포도즙"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
            
            {/* 장식 요소 */}
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-[#6B4E9C]/10 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-48 h-48 bg-purple-300/20 rounded-full blur-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
